import { render, staticRenderFns } from "./asset-group-boxes.vue?vue&type=template&id=7ff5f15d&scoped=true"
import script from "./asset-group-boxes.vue?vue&type=script&lang=js"
export * from "./asset-group-boxes.vue?vue&type=script&lang=js"
import style0 from "./asset-group-boxes.vue?vue&type=style&index=0&id=7ff5f15d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ff5f15d",
  null
  
)

export default component.exports